import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Card } from "@themesberg/react-bootstrap";

import React from "react";

export const TableSkeleton = ({ rows = 11, columns = 11 }) => {
  return (
    <Card className="mx-3 table-responsive">
      <Card.Body>
        <table className="table">
          <thead>
            <tr>
              {Array.from({ length: columns }).map((_, index) => (
                <th key={index}>
                  <Skeleton width={100} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr key={rowIndex}>
                {Array.from({ length: columns }).map((_, colIndex) => (
                  <td key={colIndex}>
                    <Skeleton width={100} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Card.Body>
    </Card>
  );
};
